import { render, staticRenderFns } from "./StatisticsList.vue?vue&type=template&id=17ebb502&scoped=true&"
import script from "./StatisticsList.vue?vue&type=script&lang=js&"
export * from "./StatisticsList.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsList.vue?vue&type=style&index=0&id=17ebb502&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ebb502",
  null
  
)

export default component.exports